<template>
<section class="role-index-container">
    <base-header v-bind="headers"
      v-on:handleCreate="handleHeaderCreate"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectKeyChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      v-on:handleDelete="handleTableDelete"
      v-on:handleRedact="handleTableRedact"
    ></base-table>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
    <form-dialog
      :title="dialogTitle"
      ref="addDialog"
      :loading="addFormLoading"
      :form="addForm"
      :rules="addRules"
      :buttons="addButtons"
      :formItems="addFormItems"
      v-on:handleConfirm="handleConfirmAdd"
    ></form-dialog>
  </section>
</template>

<script>
import role from './role'

const columns = [
  {
    prop: 'content',
    label: '内容'
  }
]
export default {
  name: 'setIndex',
  mixins: [role],
  data () {
    return {
      backUrl: '/system/role/index',
      id: '',
      dialogTitle: '新建',
      list: {
        columns,
        api: 'fetchExtcontentSetList',
        showSelection: false,
        showPaginationSimple: true,
        showPagination: false,
        params: {
          'queryType': ''
        },
        handleColumn: [
          {
            type: 'Redact',
            name: '编辑',
            icon: 'bianji',
            notDisabled: true
          },
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete',
            notDisabled: true
          }
        ],
        handleColumnProp: {
          label: '操作',
          width: '300',
          align: 'left'
        }
      },
      searchHeader: {
        searchItems: [
          {
            type: 'select',
            label: '内容类型：',
            value: 'queryType',
            options: [
              {
                value: '',
                label: '所有'
              },
              {
                value: 'POST',
                label: '录用'
              },
              {
                value: 'CANCELED',
                label: '退稿'
              },
              {
                value: 'REFUND',
                label: '返修'
              }
            ]
          }
        ]
      },
      headers: {
        buttons: [
          {
            type: 'Create',
            text: '新建',
            icon: 'xinjian',
            notDisabled: true
          }
        ],
        title: '',
        showAlertIcon: false,
        content: ''
      }

    }
  },
  activated () {
    if (this.$route.query.type === 'list') {
      this.fetchTableApi()
      this.$router.push({ query: { type: '' } })
    }
  },
  methods: {
    handleFilterParams (params, name = 'list') {
      if (params instanceof Object && this[name].filterParams instanceof Array) {
        let p = Object.assign({}, params)
        this.list.filterParams.forEach(d => {
          delete p[d]
        })
        return p
      }
      return params
    },
    handleSearchs (data) {
      if (data instanceof Array) {
        this.list.params.orgid = data[data.length - 1]
      }
      this.list.pageNo = 1
      this.fetchTableApi()
    },
    // 表格操作按钮
    handleTableDelete (row, index) {
      this.msgDialog.type = 'DeleteOne'
      this.msgDialog.content = '是否确定删除？'
      this.msgDialog.data = row.id
      this.showMsgDialog()
    },
    // 编辑
    handleTableRedact (row) {
      this.dialogTitle = '编辑'
      this.id = row.id
      this.addForm = { content: row.content, type: row.type }
      this.$refs.addDialog.showDialog()
    },
    handleHeaderCreate () {
      this.dialogTitle = '新建'
      this.id = ''
      this.addForm = { content: '', type: '' }
      this.$refs.addDialog.showDialog()
    },
    // 弹出框操作按钮
    handleConfirmMsg (type) {
      switch (type) {
        case 'DeleteOne':
          this.fetchExtcontentSetDelete(this.msgDialog.data)
          break
      }
    },
    fetchExtcontentSetDelete (id) {
      this.list.loading = true
      var params = {
        id: id
      }
      this.$request.fetchExtcontentSetDelete(params).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map((d, i) => {
          d.disabled = !d.managerAble
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box-items{
    padding: 0 9px;
  }
</style>
